import React, { createContext, useContext, useEffect, useState } from "react"
import { onAuthStateChanged } from "firebase/auth"
import { getAdminAuth, prepareAdminAuth } from "../../firebase/auth"

const AdminAuthContext = createContext(undefined)

const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [isResolving, setIsResolving] = useState(true)

  useEffect(() => {
    let isActive = true
    let unsubscribe

    prepareAdminAuth()
      .then(() => {
        if (!isActive) return

        unsubscribe = onAuthStateChanged(
          getAdminAuth(),
          currentUser => {
            if (!isActive) return
            setUser(currentUser)
            setIsResolving(false)
          },
          error => {
            if (process.env.NODE_ENV === "development") {
              console.error("Unable to resolve the admin session.", error)
            }
            if (isActive) setIsResolving(false)
          }
        )
      })
      .catch(error => {
        if (process.env.NODE_ENV === "development") {
          console.error("Unable to initialize admin authentication.", error)
        }
        if (isActive) setIsResolving(false)
      })

    return () => {
      isActive = false
      if (unsubscribe) unsubscribe()
    }
  }, [])

  return (
    <AdminAuthContext.Provider value={{ user, isResolving }}>
      {children}
    </AdminAuthContext.Provider>
  )
}

const useAdminAuth = () => {
  const context = useContext(AdminAuthContext)

  if (!context) {
    throw new Error("useAdminAuth must be used within AdminAuthProvider")
  }

  return context
}

export { AdminAuthProvider, useAdminAuth }
